import client from "api/config";
import { convertNum } from "helper/convert-num";

//////////////////// education ////////////////////
const educationUrl = "educations";
// get all educations data
export const getEducationDataRequest = (values) =>
  client.get(educationUrl, values);

// add education
export const addEducationRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  values.title && formData.append("title", values.title);
  values.text && formData.append("text", values.text);
  formData.append("alt", values.alt);
  formData.append("meta_description", values.meta_description);
  formData.append("keyword", values.keyword);
  formData.append("show_in_home_page", values.show_in_home_page);
  values.category_id && formData.append("category_id", values.category_id);
  !values.main_image.isWeb &&
    formData.append("main_image", values.main_image.url);
  values.video.isChanged && formData.append("video", values.video.url);
  return client.post(`admin/${educationUrl}`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

// update education
export const updateEducationRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  values.title && formData.append("title", values.title);
  values.text && formData.append("text", values.text);
  formData.append("alt", values.alt);
  formData.append("meta_description", values.meta_description);
  formData.append("keyword", values.keyword);
  formData.append("show_in_home_page", values.show_in_home_page);
  values.category_id && formData.append("category_id", values.category_id);
  !values.main_image.isWeb &&
    formData.append("main_image", values.main_image.url);
  values.video.isChanged && formData.append("video", values.video.url);

  return client.post(
    `admin/${educationUrl}/${values.id}?_method=put`,
    formData,
    {
      onUploadProgress: (progress) =>
        onUploadProgress((progress.loaded / progress.total) * 100),
    }
  );
};

// get education by id
export const getEducationByIdRequest = (values) => {
  return client.get(`${educationUrl}/${values.id}`);
};
// delete education by id
export const deleteEducationByIdRequest = (id) =>
  client.delete(`admin/${educationUrl}/${id}`);

/////// education category ///////
const educationCategoryUrl = "/education_categories";

// get all education category
export const getEducationCategoryRequest = (values) =>
  client.get(`${educationCategoryUrl}?
  skip=${values.skip ?? 0}&limit=${values.limit ?? 10}
    ${values.search ? "&search=" + convertNum(values.search) : ""}`);

// get education category by id
export const getEducationCategoryByIdRequest = (values) =>
  client.get(`${educationCategoryUrl}/${values.id}`);

// add education category
export const addEducationCategoryRequest = (values) =>
  client.post(`/admin${educationCategoryUrl}`, values);

// edit education category
export const editEcudationCategoryRequest = (values) =>
  client.post(`/admin${educationCategoryUrl}/${values.id}?_method=put`, values);
// delete education category
export const deleteEducationCategoryByIdRequest = (id) =>
  client.delete(`admin${educationCategoryUrl}/${id}`);
